// Файл для удобного переключения на тестовый вариант API

// live mode
import SendRequestOrig from "./SendRequestOrig";
export default SendRequestOrig;

// // testing mode
// import sendRequestTest from "@/function/global/sendRequestTest";
// export default sendRequestTest
